import React from 'react';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { ModalTitleVariant } from '@fiverr-private/content_reporting';
import { ROLLOUTS } from '../../../../../types/rollouts';
import { GigReportCta } from './GigReportCta';
import { WorkSampleReportCta } from './WorkSampleReportCta';

interface SlideReportActionProps {
  isWorkSample: boolean;
  filerrAttachmentId?: string;
  attachmentId?: string;
  encryptedOrderId?: string;
  title: ModalTitleVariant;
}

export const SlideReportAction: React.FC<SlideReportActionProps> = ({
  isWorkSample,
  filerrAttachmentId,
  attachmentId,
  encryptedOrderId,
  title,
}) => {
  const {
    rollouts: { [ROLLOUTS.CARIBOU_PORTFOLIO_ATTACHMENT_REPORT_ELIGIBILITY]: inRollout },
  } = useGigPageContext();

  if (!inRollout) {
    return null;
  }

  if (isWorkSample && filerrAttachmentId) {
    return (
      <WorkSampleReportCta
        deliveryId={attachmentId}
        filerrAttachmentId={filerrAttachmentId}
        orderId={encryptedOrderId}
        title={title}
      />
    );
  }

  return <GigReportCta />;
};
